import React, {useEffect, useLayoutEffect, useRef, useState} from "react";
import styled from "styled-components";
import img_select_default from "images/community/select_default.svg";
import img_select_hover from "images/community/select_hover.svg";
import {SsqImages} from "images/SsqImages";
import {fontFamilyBold, fontFamilyMedium, fontFamilyRegular} from "style/fonts";
import img_tag_item_close_blue from "images/common/close_icon_blue.svg";
import img_icon_keyword_search from "images/community/icon_keyword_search.svg";
import img_icon_filter from "images/community/icon_filter.svg";
import img_icon_filter_on from "images/community/icon_filter_on.svg";
import clsx from "clsx";
import {CategoryRepository, emptyCategory, ICategory} from "repositories/category/CategoryRepository";
import {LanguageService} from "language/LanguageService";
import axios from "axios";
import {IfTagListEntity} from "models/IfTagListEntity";
import {RECENT_FILTER_SEARCH_VALUE_STORAGE_KEY} from "util/LocalStorageWrapper";
import {isEqual} from "lodash-es";
import {cookieutil} from "../../util/cookieutil";
import {TagSearchWrap} from "style/CommonStyledComponents";

interface Props {
  page: "sample";
  setSrchParam?: Function;
  categoryRepository?: CategoryRepository;
  languageService?: LanguageService;
  loadingRequest?: boolean;
  outerClickedTag?: string;
  reset?: boolean;
}

export const SORT_TYPE = Object.freeze({
  RECENT: "RECENT",
  UPDATE: "UPDATE",
  POPULAR: "POPULAR"
});

export const SAMPLE_DOC_TYPE = Object.freeze({
  DEFAULT: "DEFAULT",
  SAMPLE: "SAMPLE",
  USER_SAMPLE: "USER_SAMPLE"
});

export const SOFTWARE_TYPE = Object.freeze({
  DEFAULT: "DEFAULT",
  XG5000: "XG5000",
  XP_BUILDER: "XP_BUILDER",
  DRIVEVIEW: "DRIVEVIEW"
});

export const TYPE = Object.freeze({
  DEFAULT: "DEFAULT",
  SAMPLE: "SAMPLE",
  LIBRARY: "LIBRARY",
  TEMPLATE: "TEMPLATE",
});


export const PRODUCT_TYPE = Object.freeze({
  DEFAULT: emptyCategory,
});

export const PERIOD_TYPE = Object.freeze({
  DEFAULT: "DEFAULT",
  WEEK: "WEEK",
  ONEMONTH: "ONEMONTH",
  SIXMONTH: "SIXMONTH",
  YEAR: "YEAR"
});

interface ISrchParam {
  sortType: string;
  sampleDocType: string;
  softwareType: string;
  type: string;
  prodType: ICategory;
  periodType: string;
  tagType: string[];
  keyword: string;
}

export const SampleFilter = (props: Props) => {
  const [srchParam, setSrchParam] = useState<ISrchParam>({
    sortType: SORT_TYPE.RECENT,
    sampleDocType: SAMPLE_DOC_TYPE.DEFAULT,
    softwareType: SOFTWARE_TYPE.DEFAULT,
    type: TYPE.DEFAULT,
    prodType: PRODUCT_TYPE.DEFAULT,
    periodType: PERIOD_TYPE.DEFAULT,
    tagType: [],
    keyword: ''
  });
  const [tagOpen, setTagOpen] = useState(false);
  const [filterOpen, setFilterOpen] = useState(false);

  // 공통 필터 부분
  const [sortOpen, setSortOpen] = useState(false);
  const [prodOpen, setProdOpen] = useState(false);
  const [periodOpen, setPeriodOpen] = useState(false);

  //sample 필터
  const [sampleDocTypeOpen, setSampleDocTypeOpen] = useState(false);
  const [softwareTypeOpen, setSoftwareTypeOpen] = useState(false);
  const [typeOpen, setTypeOpen] = useState(false);

  const [keyword, setKeyword] = useState('');
  const [tagClick, setTagClick] = useState(false);
  const [tagFilterString, setTagFilterString] = useState('');
  const [filteredTagList, setFilteredTagList] = useState(new Array<IfTagListEntity>);

  // 제품명
  const [products, setProducts] = useState(new Array<ICategory>);

  const [tagList, setTagList] = useState(new Array<IfTagListEntity>);

  const [selectedTagFilterNum, setSelectedTagFilterNum] = useState(-1);

  const inputRef = useRef<HTMLInputElement>(null);
  const menuRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent): void {
      if (
        menuRef.current &&
        !menuRef.current.contains(e.target as Node)
      ) {
        setOpenedFilter('');
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuRef]);

  useEffect(() => {
    resetFilter();
  }, [props.reset]);

  useLayoutEffect(() => {
    if (inputRef.current !== null) inputRef.current.focus();
  });

  useEffect(() => {
    props.setSrchParam(srchParam);
  }, [srchParam]);

  useEffect(() => {
    if (props.outerClickedTag !== '') clickTag(tagList.find(tag => tag.tag === props.outerClickedTag));
  }, [props.outerClickedTag]);

  const setOpenedFilter = (filterName: String) => {
    setSortOpen(filterName === "sort" ? !sortOpen : false);
    setSampleDocTypeOpen(filterName === "sample-doc-type" ? !sampleDocTypeOpen : false);
    setSoftwareTypeOpen(filterName === "software-type" ? !softwareTypeOpen : false);
    setTypeOpen(filterName === 'type' ? !typeOpen : false);
    setProdOpen(filterName === "prod" ? !prodOpen : false);
    setPeriodOpen(filterName === "period" ? !periodOpen : false);
    setTagOpen(filterName === "tag" ? !tagOpen : false);

  };

  const sortKindOn = () => {
    console.log("-- sortKindOn", sortOpen);
    setOpenedFilter("sort");
  };

  const sampleDocTypeOn = () => {
    console.log("-- sampleOn", sampleDocTypeOpen);
    setOpenedFilter("sample-doc-type");
  };

  const softwareTypeOn = () => {
    console.log("-- softwareOn", softwareTypeOpen);
    setOpenedFilter('software-type');
  };

  const typeOn = () => {
    console.log("-- filetypeOn", typeOpen);
    setOpenedFilter('type');
  };

  const prodKindOn = () => {
    console.log("-- prodOn", prodOpen);
    setOpenedFilter('prod');
  };

  const periodKindOn = () => {
    console.log("-- periodOn", periodOpen);
    setOpenedFilter('period');
  };

  const tagKindOn = () => {
    console.log("-- tagKindOn", tagOpen);
    setOpenedFilter('tag');
    setTagClick(tagOpen);
  };

  const mobileSelectView = () => {
    setFilterOpen(!filterOpen);
  };

  const sortType = srchParam.sortType;
  const sortTypeStr = (t) => {
    if (!t) return getTranslation("I18N_COMMUNITY_FILTER_RECENT");
    if (t == SORT_TYPE.RECENT) return getTranslation("I18N_COMMUNITY_FILTER_RECENT");
    if (t === SORT_TYPE.UPDATE) return getTranslation("I18N_COMMUNITY_FILTER_UPDATED");
    if (t === SORT_TYPE.POPULAR) return getTranslation("I18N_COMMUNITY_FILTER_POPULAR");
    return getTranslation("I18N_COMMUNITY_FILTER_RECENT");
  };

  const periodType = srchParam.periodType;
  const periodTypeStr = (p) => {
    if (!p) return getTranslation("I18N_COMMUNITY_FILTER_PERIOD");
    if (p == PERIOD_TYPE.DEFAULT) return getTranslation("I18N_COMMUNITY_FILTER_PERIOD");
    if (p == PERIOD_TYPE.WEEK) return getTranslation("I18N_COMMUNITY_FILTER_ONE_WEEK");
    if (p === PERIOD_TYPE.ONEMONTH) return getTranslation("I18N_COMMUNITY_FILTER_ONE_MONTH");
    if (p === PERIOD_TYPE.SIXMONTH) return getTranslation("I18N_COMMUNITY_FILTER_SIX_MONTH");
    if (p == PERIOD_TYPE.YEAR) return getTranslation("I18N_COMMUNITY_FILTER_ONE_YEAR");
    return getTranslation("I18N_COMMUNITY_FILTER_PERIOD");
  };

  const prodType = srchParam.prodType;
  const prodTypeStr = (p) => {
    if (!p) return getTranslation("I18N_COMMUNITY_FILTER_PRODUCT");
    if (p === PRODUCT_TYPE.DEFAULT) return getTranslation("I18N_COMMUNITY_FILTER_PRODUCT");
    return p;
  };

  const sampleDocType = srchParam.sampleDocType;
  const sampleDocTypeStr = (p) => {
    if (!p) return trans('I18N_SERVICE_FILTER_SAMPLE_DOC_TYPE');
    if (p == SAMPLE_DOC_TYPE.DEFAULT) return trans('I18N_SERVICE_FILTER_SAMPLE_DOC_TYPE');
    if (p === SAMPLE_DOC_TYPE.SAMPLE) return getTranslation('I18N_LS_SAMPLE');
    if (p === SAMPLE_DOC_TYPE.USER_SAMPLE) return getTranslation('I18N_USER_SAMPLE');
    return trans('I18N_SERVICE_FILTER_SAMPLE_DOC_TYPE');
  };

  const softwareType = srchParam.softwareType;
  const softwareTypeStr = (p) => {
    if (!p) return trans('I18N_SERVICE_FILTER_SOFTWARE_TYPE');
    if (p === SOFTWARE_TYPE.DEFAULT) return trans('I18N_SERVICE_FILTER_SOFTWARE_TYPE');
    if (p === SOFTWARE_TYPE.XG5000) return trans('I18N_SERVICE_FILTER_XG5000');
    if (p === SOFTWARE_TYPE.XP_BUILDER) return trans('I18N_SERVICE_FILTER_XP_BUILDER');
    if (p === SOFTWARE_TYPE.DRIVEVIEW) return trans('I18N_SERVICE_FILTER_DRIVEVIEW');
    return trans('I18N_SERVICE_FILTER_SOFTWARE_TYPE');
  };

  const type = srchParam.type;
  const typeStr = (t) => {
    if (!t) return trans('I18N_SERVICE_FILTER_TYPE');
    if (t === TYPE.DEFAULT) return trans('I18N_SERVICE_FILTER_TYPE');
    if (t === TYPE.SAMPLE) return trans('I18N_SERVICE_FILTER_SAMPLE');
    if (t === TYPE.LIBRARY) return trans('I18N_SERVICE_FILTER_LIBRARY');
    if (t === TYPE.TEMPLATE) return trans('I18N_SERVICE_FILTER_TEMPLATE');
    return trans('I18N_SERVICE_FILTER_TYPE');
  };


  const handleClick = (e, cmd: string, data?) => {
    //if( e && e.preventDefault) e.preventDefault();
    console.log(e, "cmd ", cmd, " data ", data);
    switch (cmd) {
      case 'sort-click' :
        setSrchParam({...srchParam, sortType: data});
        setSortOpen(!sortOpen);
        return console.log("-- sortKindOn", srchParam);

      case 'sample-doc-type-click' :
        setSrchParam({...srchParam, sampleDocType: data});
        setSampleDocTypeOpen(!sampleDocTypeOpen);
        return console.log("-- sampleKindOn", srchParam);

      case 'software-type-click' :
        setSrchParam({...srchParam, softwareType: data});
        setSoftwareTypeOpen(!softwareTypeOpen);
        return console.log("-- softwareKindOn", srchParam);

      case 'type-click':
        setSrchParam({...srchParam, type: data});
        setTypeOpen(!typeOpen);
        return console.log("-- typeKindOn", srchParam);

      case 'prod-click' :
        setSrchParam({...srchParam, prodType: data});
        setProdOpen(!prodOpen);
        return console.log("-- prodKindOn", srchParam);

      case 'period-click' :
        setSrchParam({...srchParam, periodType: data});
        setPeriodOpen(!periodOpen);
        return console.log("-- periodKindOn", srchParam);

      default :
        return console.error("error cmd ", cmd, " data ", data);
    }
  };

  const updateLocalStorage = (tag: string) => {
    let tmpStorageTags = localStorage.getItem(RECENT_FILTER_SEARCH_VALUE_STORAGE_KEY)?.split(",") || [];
    if (!tmpStorageTags.find(storageTag => storageTag === tag)) {
      tmpStorageTags.unshift(tag);
      if (tmpStorageTags.length > 5) tmpStorageTags = tmpStorageTags.filter((tag, index) => index !== tmpStorageTags.length - 1);
      localStorage.setItem(RECENT_FILTER_SEARCH_VALUE_STORAGE_KEY, tmpStorageTags.toString());
    } else {
      let tmp = tmpStorageTags[tmpStorageTags.findIndex(storageTag => storageTag === tag)];
      tmpStorageTags.splice(tmpStorageTags.findIndex(storageTag => storageTag === tag), 1);
      tmpStorageTags.unshift(tmp);
      localStorage.setItem(RECENT_FILTER_SEARCH_VALUE_STORAGE_KEY, tmpStorageTags.toString());
    }
  };

  const clickTag = (tag: IfTagListEntity) => {
    if (tag) {
      let tmpTagParam = srchParam.tagType;
      if (!tmpTagParam.find(selTag => selTag === tag.tag) && tmpTagParam.length < 3) {
        if (cookieutil.isAcceptFunctionConsentCookie(props.languageService.lang())) updateLocalStorage(tag.tag);
        tmpTagParam.push(tag.tag);
        setSrchParam({...srchParam, tagType: tmpTagParam});
      } else if (tmpTagParam.length === 3) alert(getTranslation("I18N_COMMUNITY_FILTER_ALERT_MANY_TAG"));
      setTagFilterString('');
      setSelectedTagFilterNum(-1);
      setTagOpen(false);
    }
  };

  const clickRemoveTag = (tag: String) => {
    let tmpTagParam = srchParam.tagType.filter(selTag => tag !== selTag);
    setSrchParam({...srchParam, tagType: tmpTagParam});
  };

  const getTranslation = (key: string) => {
    props.languageService.setNamespace("I18N_NAMESPACE_COMMUNITY_PAGE");
    return props.languageService.getTranslationByKey(key) || "";
  };

  const trans = (key: string) => {
    props.languageService.setNamespace("I18N_NAMESPACE_SERVICE_PAGE");
    return props.languageService.getTranslationByKey(key) || "";
  };

  useEffect(() => {
    if (props.categoryRepository) {
      props.categoryRepository.getExposedCategories(props.languageService.getLanguage()).then((res) => {
        let tmpProduct = res.reduce((prev, curr) => {
          if (curr.level === 1) prev.push(curr);
          return prev;
        }, [] as Array<ICategory>);
        tmpProduct.sort((a, b) => a.sequence - b.sequence);
        setProducts(tmpProduct);
      }).catch((err) => {
        console.log(err);
      });
    }

    axios.get('/api/guest/ssqData/taglist/list', {
      params: {
        lang: props.languageService.getLanguage(),
        types: 'TAG,APPLICATION_LOAD,DOC_TYPE,INDUSTRY,PRODUCT'
      }
    }).then(res => {
      setTagList(res.data || []);
    });
  }, []);

  useEffect(() => {
    console.log(tagFilterString);
    setSelectedTagFilterNum(-1);
    let tmpFilteredTagList = tagList.filter((tag) => {
      if (tag.tag.toLowerCase().startsWith(tagFilterString.toLowerCase()))
        return tag;
    });
    setFilteredTagList(tmpFilteredTagList || []);
  }, [tagFilterString]);

  const onKeyDownForRecentSearch = (e, len: number) => {
    if (e.key === 'ArrowUp') {
      if (selectedTagFilterNum < 0) setSelectedTagFilterNum(len - 1);
      else setSelectedTagFilterNum(selectedTagFilterNum - 1);
    } else if (e.key === 'ArrowDown') {
      if (selectedTagFilterNum > len - 1) setSelectedTagFilterNum(-1);
      else setSelectedTagFilterNum(selectedTagFilterNum + 1);
    } else if (e.key === 'Enter') {
      if (selectedTagFilterNum < 0) {
        clickTag(filteredTagList[0]);
      }
      if (tagFilterString === '') {
        clickTag(tagList.find(tag =>
          tag.tag === localStorage.getItem(RECENT_FILTER_SEARCH_VALUE_STORAGE_KEY).split(",")[selectedTagFilterNum]
        ));
      } else {
        clickTag(filteredTagList[selectedTagFilterNum]);
      }
    }
    console.log(selectedTagFilterNum);
  };

  const resetFilter = () => {
    setSrchParam({
      sortType: SORT_TYPE.RECENT,
      sampleDocType: SAMPLE_DOC_TYPE.DEFAULT,
      softwareType: SOFTWARE_TYPE.DEFAULT,
      type: TYPE.DEFAULT,
      prodType: PRODUCT_TYPE.DEFAULT,
      periodType: PERIOD_TYPE.DEFAULT,
      tagType: [],
      keyword: ''
    });
    setKeyword('');
  };

  const resetKeyword = () => {
    setSrchParam({
      ...srchParam,
      keyword: ""
    });
    setKeyword('');
  };

  return (
    <FilterContainer className="inquiry-box" keyword={keyword}>
      <div className={clsx("select-mobile", filterOpen ? 'on' : '')}>
        <div className="left-blur"></div>
        <div className="right-blur"></div>
        <ul>
          <li className={clsx("select-title", "sort-kind", "active")}
            onClick={() => sortKindOn()}>
            <span className={clsx("title",)}>{sortTypeStr(sortType)}</span><span
            className={clsx("arrow", sortOpen ? 'on' : '')}></span>
          </li>
          {props.page === 'sample' && (
            <>
              <li className={clsx("select-title", "sample-doc-type-kind", srchParam.sampleDocType === SAMPLE_DOC_TYPE.DEFAULT ? '' : 'active')}
                onClick={() => sampleDocTypeOn()}>
                <span className="title">{sampleDocTypeStr(sampleDocType)}</span><span
                className={clsx("arrow", sampleDocTypeOpen ? 'on' : '')}></span>
              </li>

              <li className={clsx("select-title", "software-doc-type-kind", srchParam.softwareType === SOFTWARE_TYPE.DEFAULT ? '' : 'active')}
                onClick={() => softwareTypeOn()}>
                <span className="title">{softwareTypeStr(softwareType)}</span><span
                className={clsx("arrow", softwareTypeOpen ? 'on' : '')}></span>
              </li>

              <li className={clsx("select-title", "type-kind", srchParam.type === TYPE.DEFAULT ? '' : 'active')}
                onClick={() => typeOn()}>
                <span className="title">{typeStr(type)}</span><span
                className={clsx("arrow", typeOpen ? 'on' : '')}></span>
              </li>
            </>

          )}

          <li className={clsx("select-title", "prod-kind", srchParam.prodType === PRODUCT_TYPE.DEFAULT ? '' : 'active')}
            onClick={() => prodKindOn()}>
            <span className="title">{prodTypeStr(prodType.name)}</span><span
            className={clsx("arrow", prodOpen ? 'on' : '')}></span>
          </li>

          <li className={clsx("select-title", "period-kind", srchParam.periodType === PERIOD_TYPE.DEFAULT ? '' : 'active')}
            onClick={() => periodKindOn()}>
            <span className="title">{periodTypeStr(periodType)}</span><span
            className={clsx("arrow", periodOpen ? 'on' : '')}></span>
          </li>
          {/*---- 테그 추가되면 모바일 버전은 여기에 추가 됩니다. ---*/}
          {srchParam.tagType.map(selTag => (
            <li key={selTag} className="select-title tag-plus-item ">
              <span className="title">{selTag}</span>
              <button className="tag-item-close" onClick={() => clickRemoveTag(selTag)}></button>
            </li>
          ))}
          {/*---- 테그 추가되면 모바일 버전은 여기에 추가 됩니다. ---*/}
          <li className={clsx("select-title", "s-tag", tagOpen ? 'active' : tagClick ? '' : 'active')}
            onClick={() => tagKindOn()}>
            <span className="plus"></span><span className="title">{getTranslation("I18N_COMMUNITY_FILTER_TAG")}</span>
          </li>
        </ul>
      </div>
      <div className="inquiry-list" ref={menuRef}>
        <div className="select-item">
          <div className={clsx("select-title", "sort-kind", 'active')}
            onClick={() => sortKindOn()}>
            <span className={clsx("title",)}>{sortTypeStr(sortType)}</span><span
            className={clsx("arrow", sortOpen ? 'on' : '')}></span>
          </div>
          <ul className={clsx("select-list", "sort-kind-list")}
            style={{display: sortOpen ? 'block' : 'none'}}>
            <li
              onClick={(e) => handleClick(e, 'sort-click', SORT_TYPE.RECENT)}>{getTranslation("I18N_COMMUNITY_FILTER_RECENT")}
            </li>
            <li
              onClick={(e) => handleClick(e, 'sort-click', SORT_TYPE.UPDATE)}>{getTranslation("I18N_COMMUNITY_FILTER_UPDATED")}
            </li>
            <li
              onClick={(e) => handleClick(e, 'sort-click', SORT_TYPE.POPULAR)}>{getTranslation("I18N_COMMUNITY_FILTER_POPULAR")}
            </li>
          </ul>
        </div>

        {props.page === 'sample' && (
          <>
            <div className="select-item">
              <div className={clsx("select-title", "sample-doc-type-kind", srchParam.sampleDocType === SAMPLE_DOC_TYPE.DEFAULT ? '' : 'active')}
                onClick={() => sampleDocTypeOn()}>
                <span className={clsx("title",)}>{sampleDocTypeStr(sampleDocType)}</span><span
                className={clsx("arrow", sampleDocTypeOpen ? 'on' : '')}></span>
              </div>
              <ul className={clsx("select-list", "sample-doc-type-list",)}
                style={{display: sampleDocTypeOpen ? 'block' : 'none'}}>
                <li
                  onClick={(e) => handleClick(e, 'sample-doc-type-click', SAMPLE_DOC_TYPE.DEFAULT)}>{trans('I18N_SERVICE_FILTER_ALL')}
                </li>
                <li
                  onClick={(e) => handleClick(e, 'sample-doc-type-click', SAMPLE_DOC_TYPE.SAMPLE)}>{getTranslation('I18N_LS_SAMPLE')}
                </li>
                <li
                  onClick={(e) => handleClick(e, 'sample-doc-type-click', SAMPLE_DOC_TYPE.USER_SAMPLE)}>{getTranslation('I18N_USER_SAMPLE')}
                </li>
              </ul>
            </div>


            <div className="select-item">
              <div className={clsx("select-title", "software-type-kind", srchParam.softwareType === SOFTWARE_TYPE.DEFAULT ? '' : 'active')}
                onClick={() => softwareTypeOn()}>
                <span className={clsx("title",)}>{softwareTypeStr(softwareType)}</span><span
                className={clsx("arrow", softwareTypeOpen ? 'on' : '')}></span>
              </div>
              <ul className={clsx("select-list", "software-type-list",)}
                style={{display: softwareTypeOpen ? 'block' : 'none'}}>
                <li
                  onClick={(e) => handleClick(e, 'software-type-click', SOFTWARE_TYPE.DEFAULT)}>{trans('I18N_SERVICE_FILTER_ALL')}
                </li>
                <li
                  onClick={(e) => handleClick(e, 'software-type-click', SOFTWARE_TYPE.XG5000)}>{trans('I18N_SERVICE_FILTER_XG5000')}
                </li>
                <li
                  onClick={(e) => handleClick(e, 'software-type-click', SOFTWARE_TYPE.XP_BUILDER)}>{trans('I18N_SERVICE_FILTER_XP_BUILDER')}
                </li>
                <li
                  onClick={(e) => handleClick(e, 'software-type-click', SOFTWARE_TYPE.DRIVEVIEW)}>{trans('I18N_SERVICE_FILTER_DRIVEVIEW')}
                </li>
              </ul>
            </div>

            <div className="select-item">
              <div className={clsx("select-title", "type-kind", srchParam.type === TYPE.DEFAULT ? '' : 'active')}
                onClick={() => typeOn()}>
                <span className={clsx("title",)}>{typeStr(type)}</span><span
                className={clsx("arrow", typeOpen ? 'on' : '')}></span>
              </div>
              <ul className={clsx("select-list", "type-list",)}
                style={{display: typeOpen ? 'block' : 'none'}}>
                <li
                  onClick={(e) => handleClick(e, 'type-click', TYPE.DEFAULT)}>{trans('I18N_SERVICE_FILTER_ALL')}
                </li>
                <li
                  onClick={(e) => handleClick(e, 'type-click', TYPE.SAMPLE)}>{trans('I18N_SERVICE_FILTER_SAMPLE')}
                </li>
                <li
                  onClick={(e) => handleClick(e, 'type-click', TYPE.LIBRARY)}>{trans('I18N_SERVICE_FILTER_LIBRARY')}
                </li>
                <li
                  onClick={(e) => handleClick(e, 'type-click', TYPE.TEMPLATE)}>{trans('I18N_SERVICE_FILTER_TEMPLATE')}
                </li>
              </ul>
            </div>

          </>
        )
        }

        <div className="select-item">
          <div className={clsx("select-title", "prod-kind", srchParam.prodType === PRODUCT_TYPE.DEFAULT ? '' : 'active')}
            onClick={() => prodKindOn()}>
            <span className={clsx("title",)}>{prodTypeStr(prodType.name)}</span><span
            className={clsx("arrow", prodOpen ? 'on' : '')}></span>
          </div>
          <ul className={clsx("select-list", "prod-kind-list",)}
            style={{display: prodOpen ? 'block' : 'none'}}>
            <li
              onClick={(e) => handleClick(e, 'prod-click', emptyCategory)}>{getTranslation("I18N_COMMUNITY_FILTER_ALL")}
            </li>
            {products.map(product => (<li key={product.name} onClick={(e) => handleClick(e, 'prod-click', product)}>
              {product.name}
            </li>))}

          </ul>
        </div>

        <div className="select-item">
          <div className={clsx("select-title", "period-kind", srchParam.periodType === PERIOD_TYPE.DEFAULT ? '' : 'active')}
            onClick={() => periodKindOn()}>
            <span className={clsx("title",)}>{periodTypeStr(periodType)}</span><span
            className={clsx("arrow", periodOpen ? 'on' : '')}></span>
          </div>
          <ul className={clsx("select-list", "prod-kind-list",)}
            style={{display: periodOpen ? 'block' : 'none'}}>
            <li
              onClick={(e) => handleClick(e, 'period-click', PERIOD_TYPE.DEFAULT)}>{getTranslation("I18N_COMMUNITY_FILTER_ALL")}
            </li>
            <li
              onClick={(e) => handleClick(e, 'period-click', PERIOD_TYPE.WEEK)}>{getTranslation("I18N_COMMUNITY_FILTER_ONE_WEEK")}
            </li>
            <li
              onClick={(e) => handleClick(e, 'period-click', PERIOD_TYPE.ONEMONTH)}>{getTranslation("I18N_COMMUNITY_FILTER_ONE_MONTH")}
            </li>
            <li
              onClick={(e) => handleClick(e, 'period-click', PERIOD_TYPE.SIXMONTH)}>{getTranslation("I18N_COMMUNITY_FILTER_SIX_MONTH")}
            </li>
            <li
              onClick={(e) => handleClick(e, 'period-click', PERIOD_TYPE.YEAR)}>{getTranslation("I18N_COMMUNITY_FILTER_ONE_YEAR")}
            </li>
          </ul>
        </div>
        {srchParam.tagType.map(selTag => (
          <div key={selTag} className="select-item tag-plus-item" onClick={() => clickRemoveTag(selTag)}>
            <span className="title">{selTag}</span>
            <button className="tag-item-close"></button>
          </div>
        ))}
        <div className="select-item select-tag" onKeyDown={e => {
          if (tagFilterString == '')
            onKeyDownForRecentSearch(e, localStorage.getItem(RECENT_FILTER_SEARCH_VALUE_STORAGE_KEY)?.split(",").length || 0);
          else
            onKeyDownForRecentSearch(e, filteredTagList.length);
        }}>
          <TagSearchWrap>
            <div className={clsx("select-title", "s-tag", tagOpen ? 'active' : tagClick ? '' : 'active')}
              onClick={() => tagKindOn()}>
              <span className="plus"></span><span className="title">{getTranslation("I18N_COMMUNITY_FILTER_TAG")}</span></div>
            <div className="tag-search" style={{display: tagOpen ? 'block' : 'none'}}>
              <div className="tag-input-item">
                <input ref={inputRef} type="text" className="tag-input" value={tagFilterString} onChange={e => {
                  setTagFilterString(e.target.value);
                }}/>
                {tagFilterString !== "" &&
                  <button className="close" onClick={(e) => setTagFilterString("")}></button>}
              </div>
              <ul className={clsx("tag-last")}>
                {tagFilterString == '' && localStorage.getItem(RECENT_FILTER_SEARCH_VALUE_STORAGE_KEY)?.split(",").map((recentTag, index) => (
                  <li key={recentTag} className={`${selectedTagFilterNum === index && 'on'}`} onClick={() => {
                    let array = tagList.filter(tag => tag.tag == recentTag);
                    if (array[0] == null) {
                      alert(getTranslation("I18N_COMMUNITY_ALERT_TAG_INVALID"));
                    } else {
                      clickTag(tagList.find(tag => tag.tag === recentTag));
                    }
                  }}>{recentTag}</li>
                ))
                }
              </ul>
              <ul className="tag-plus">
                {tagFilterString != '' && filteredTagList?.map((tag, index) => {
                    return <li key={tag.tag} className={`${selectedTagFilterNum === index && 'on'}`} onClick={() => {
                      clickTag(tag);
                    }}><span>{tag.tag.substring(0, tagFilterString.length)}</span>{tag.tag.substring(tagFilterString.length)}</li>;
                  }
                )}
              </ul>
            </div>
          </TagSearchWrap>
        </div>
        {
          !isEqual(srchParam, {
            sortType: SORT_TYPE.RECENT,
            sampleDocType: SAMPLE_DOC_TYPE.DEFAULT,
            softwareType: SOFTWARE_TYPE.DEFAULT,
            type: TYPE.DEFAULT,
            prodType: PRODUCT_TYPE.DEFAULT,
            periodType: PERIOD_TYPE.DEFAULT,
            tagType: [],
            keyword: ''
          }) &&
          <div className={"filter-init"} onClick={() => {
            resetFilter();
          }}>
            {getTranslation("I18N_COMMUNITY_FILTER_RESET")}
          </div>
        }


      </div>
      <div className="search-keyword">
        <input type="text" className="input-keyword" placeholder={getTranslation("I18N_COMMUNITY_PLACEHOLDER")} value={keyword}
          onKeyDown={(e) => {
            if (e.key === 'Enter') setSrchParam({...srchParam, keyword: keyword.trimStart()});
          }} onChange={e => setKeyword(e.target.value)}/>
        {keyword !== "" &&
          <button className="close" onClick={() => {
            resetKeyword();
          }}></button>
        }
        <button className="ent" onClick={() => {
          setSrchParam({...srchParam, keyword: keyword.trimStart()});
        }}></button>
      </div>
      <button className={clsx("btn-filter", filterOpen ? 'on' : '')}
        onClick={() => mobileSelectView()}></button>
      <div className={clsx("mobile-black",
        sortOpen || sampleDocTypeOpen || softwareTypeOpen || typeOpen || prodOpen || periodOpen || tagOpen ? 'on' : '')}></div>
    </FilterContainer>
  );
};

export const FilterContainer = styled.div<{ keyword: string }>`

  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 1.6rem 3.2rem;
  background: #fff;
  border-bottom: 1px solid #C7D6EA;
  //position: sticky;
  top: 6rem;

  .filter-init {
    color: #407DD8;
    ${fontFamilyBold};
    font-size: 1.3rem;
    height: 3.2rem;
    line-height: 3.2rem;
    padding: 0 .4rem 0 1.6rem;
    margin-right: .4rem;
    box-sizing: border-box;
    user-select: none;
    cursor: pointer;
    flex-shrink: 0;
    position: relative;
    top: 0
  }

  .left-blur, .right-blur {
    display: none;
  }

  .select-mobile {
    display: none;
  }


  .inquiry-box {

  }

  /*셀렉트 가로 버전*/

  .inquiry-list {
    width: calc(100% - 26rem);
    background: #fff;
    position: relative;
    display: flex;
    flex-wrap: wrap;
  }

  /*select랑 키워드 검색부분 */

  .select-item {
    flex-shrink: 0;
    margin-bottom: .4rem;
  }


  .select-item .select-list {
    background: #FFFFFF;
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    position: absolute;
    z-index: 10;
    display: none;
    max-height: 43rem;
    overflow: auto;
    overflow-x: hidden;
  }

  .select-title {
    width: auto;
    height: 3.2rem;
    line-height: 3.2rem;
    color: #7783A1;
    font-size: 1.3rem;
    ${fontFamilyMedium};
    padding: 0 1rem 0 1.6rem;
    margin-right: .4rem;
    border-radius: 3rem;
    user-select: none;
    cursor: pointer;
  }

  .select-title:hover {
    background: #ebf2fb;
  }

  .select-title.active {
    color: #407DD8;
    background: #ECF2FB;
    ${fontFamilyBold};
  }

  .select-title > .arrow {
    width: 2.4rem;
    height: 2.4rem;
    display: inline-block;
    background-image: url(${img_select_default});
    background-repeat: no-repeat;
    background-position: center;
    vertical-align: middle;
    margin-left: 4px;
    transition: transform .4s;
  }

  .select-title.active > .arrow {
    background-image: url(${img_select_hover});
    background-repeat: no-repeat;
    background-position: center;
  }

  .select-title > .arrow.on {
    transform: rotate(-180deg);
  }

  .select-list {
    background: #FFFFFF;
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    position: absolute;
    z-index: 10;
    display: none;
  }

  .select-list li {
    color: #2A2C2F;
    padding: 1.2rem 1.8rem 1.2rem 1.6rem;
    border-bottom: 1px solid #C7D6EA;
    font-size: 1.2rem;
    ${fontFamilyMedium};
    user-select: none;
    cursor: pointer;
    min-width: 9.5rem;

    :hover {
      background: rgba(64, 126, 219, 0.1);
    }
  }

  .select-list li:last-child {
    border: none;
  }

  .tag-plus-item {
    display: inline-block;
    color: #407DD8 !important;
    background: #ECF2FB;
    font-weight: 700 !important;
    width: auto;
    height: 3.2rem;
    line-height: 3.2rem;
    font-size: 1.3rem;
    padding: 0 .4rem 0 1.6rem;
    margin-right: .4rem;
    border-radius: 3rem;
    box-sizing: border-box;
    user-select: none;
    cursor: pointer;
  }

  .select-tag {
    display: flex;
  }

  .tag-plus-item > button.tag-item-close {
    width: 2.4rem;
    height: 2.4rem;
    vertical-align: middle;
    background: url(${img_tag_item_close_blue}) no-repeat center;
    display: inline-block;
  }

  > .search-keyword {
    background: #EEF1F6;
    background-image: url(${img_icon_keyword_search});
    background-repeat: no-repeat;
    background-position: 1rem center;
    width: 24rem;
    height: 3.2rem;
    display: flex;
    align-items: center;
    border-radius: 2rem;
  }

  .search-keyword input.input-keyword {
    ${fontFamilyMedium};
    color: #2A2C2F;
    font-size: 1.4rem;
    margin-left: 3.2rem;
    width: calc(100% - 8.4rem);
    line-height: 1.6rem;
    margin-right: 0.4rem;
  }

  .search-keyword input.input-keyword::placeholder {
    color: #7783A1;
    font-size: 1rem;
    ${fontFamilyRegular};
  }

  .search-keyword button.ent {
    width: ${({keyword}) => keyword == "" ? '4rem' : '6rem'};
    height: 1.6rem;
    background-image: url(${SsqImages.boris.searchEnterButton()});
    background-repeat: no-repeat;
    background-size: 4rem 1.6rem;
  }

  .search-keyword button.close {
    width: 4rem;
    height: 1.6rem;
    background-image: url(${SsqImages.common.icon.closeSmallIcon()});
    background-size: 4rem 1.6rem;
    margin-right: 6px;
  }


  .btn-filter {
    width: 3.2rem;
    height: 3.2rem;
    background-image: url(${img_icon_filter});
    background-repeat: no-repeat;
    background-position: center;
    margin-left: 1.2rem;
    border-radius: 4px;
    display: none;
    flex-shrink: 0;
  }


  .btn-filter.on {
    background: #D9E5F7;
    background-image: url(${img_icon_filter_on});
    background-repeat: no-repeat;
    background-position: center;
  }

  .mobile-black {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 9;
    background: rgba(0, 0, 0, .5);
    display: none;
  }


  //모바일 사이즈 - select박스
  @media screen and (max-width: 764px) {

    margin-top: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 1.2rem 0;
    position: sticky;
    z-index: 9;
    top: 6rem;

    .filter-init {
      top: -.4rem;
    }

    .button {
      cursor: pointer;
      user-select: none;
    }

    .tag-search {
      position: fixed;
      z-index: 101;
      width: 24rem;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: none;
    }

    .select-item .select-list {
      position: fixed;
      z-index: 101;
      display: none;
      width: 20rem;
      text-align: center;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .mobile-black {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 9;
      background: rgba(0, 0, 0, .5);
      display: none;
    }

    .community__header {
      padding: 0;
    }

    .select-mobile.on {
      display: block;
    }

    .mobile-black.on {
      display: block;
    }

    .inquiry-box {

    }

    > .search-keyword {
      width: calc(100% - 2.4rem);
      height: 3.2rem;
      display: flex;
      align-items: center;
      border-radius: 2rem;
      position: sticky;
      top: 6rem;
      margin-left: 1.6rem;
      z-index: 2;
    }


    .btn-filter {
      display: block;
      margin-right: 1.6rem;
    }

    > .inquiry-list .select-title {
      display: none;
    }

    .tag-plus-item {
      display: none;
    }

    > .select-mobile {
      position: absolute;
      top: 5.6rem;
      background: #fff;
      width: 100%;
    }

    > .select-mobile.active {
      display: block;
    }

    > .select-mobile ul {
      width: 100%;
      display: flex;
      flex-wrap: nowrap;
      overflow: auto;
      -ms-overflow-style: none;
      padding: 1.2rem 1.6rem;
      height: 5.6rem;
      box-shadow: 0px 4px 18px -4px rgba(0, 0, 0, 0.1);
      border-top: .1rem solid #C7D6EA;
    }

    > .select-mobile ul::-webkit-scrollbar {
      display: none;
    }

    .inquiry-list {
      width: auto;
    }

    .left-blur {
      display: block;
      position: absolute;
      width: 2rem;
      height: 5.5rem;
      left: 0;
      top: 1px;
      background: linear-gradient(to right, #fff 30%, rgba(255, 255, 255, 0));
      z-index: 2;
    }

    .right-blur {
      display: block;
      position: absolute;
      width: 2rem;
      height: 5.5rem;
      right: 0;
      top: 1px;
      background: linear-gradient(to left, #fff 30%, rgba(255, 255, 255, 0));
      z-index: 2;
    }

    .btn-box.btn-write {
      position: absolute;
      top: 16rem;
    }

    .select-title {
      width: auto;
      height: 3.2rem;
      line-height: 3.2rem;
      padding: 0 1rem 0 1.6rem;
      border-radius: 3rem;
      flex-shrink: 0;
      display: block;
    }

    .search-keyword button.ent {
      width: ${({keyword}) => keyword == "" ? '4rem' : '4.6rem'};
      height: 1.6rem;
      background-size: 4rem 1.6rem;
      margin-right: 6px;
    }

    .search-keyword button.close {
      width: 4rem;
      height: 1.6rem;
      background-size: 4rem 1.6rem;
      margin-right: 6px;
    }
  }

}

`;